import './TableInfoCard.css';


const TableInfoCard = ({ invoices }) => {
  return (
    <div className="invoice-container">
      {/* 🔍 Barra de búsqueda */}
      <div className='membershipCard-card__section'>
        {/* <div className="invoice-search">
          <input
            type="text"
            placeholder="Search by order number and date"
            className="search-input"
          />
          <button className="search-button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="18"
              width="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#001d3d"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </button>
        </div> */}

      {/* 📊 Tabla */}
      <table className="invoice-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th>Order number</th>
            <th>Membership</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
            {invoices.map((invoice, index) => (
            <tr key={index}>
              <td>{invoice.date}</td>
              <td>{invoice.type}</td>
              <td>{invoice.orderNumber}</td>
              <td>{invoice.membership}</td>
                <td>{invoice.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* 🔽 Show more */}
      <div className="show-more">
        <button>Show more</button>
      </div>
      </div>
    </div>

    

     
  );
};

export default TableInfoCard;
